import React from "react";

export const NotFound404: React.FC = () => (
	<main>
		<h1>404 - Not found</h1>
	</main>
);
